/* eslint-disable jira/filename-case */
export const BUSINESS = 'business';
export const DEFAULT = 'default';
